export const ROUTES = {
  HOME: '/',
  CHECKOUT: '/checkout-payment/:paymentExternalId',
  PAYMENT: '/payment/:paymentExternalId',
  PAYMENT_STATUS: '/payment/:paymentExternalId/status',
  SUPPORT_PRO: '/astropay-pro/:usertag/support',
  PAYMENT_LINK: '/payment-link/:paymentLinkId',
  GENERIC_ERROR: '/error',
};
